import React from "react";
import * as Animate from "react-reveal";
import PeopleImg from "../../../assets/images/png/about.webp";

const CompanyStorySection = () => {
  return (
    <section className="py-24 lg:py-32 about-brief-section">
      <div className="container mx-auto px-4">
        <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-14 lg:gap-20">
          <div className="">
            <Animate.Fade bottom>
              <h4 className="text-3xl lg:text-4xl xl:text-5xl text-primary font-mono font-semibold text-center md:text-left w-10/12 md:w-9/12 mx-auto md:mx-0">
                Utiva is more than a company!
              </h4>
              <div className="md:hidden pt-12 pb-6">
                <img src={PeopleImg} width="100%" className="" alt="" />
              </div>
              <p className="w-full text-default pt-12 pb-6 leading-8 lg:w-10/12">
                Since 2018, we have helped professionals from over 1000 leading
                companies learn skills and develop capabilities to thrive in
                their workplaces and also stay relevant for the Future of Work.
                <br /> <br />
                Today we have people (especially Blacks and Minorities) join our
                virtual learning programs from all over 30 countries. With an
                ecosystem of over 90,000 talents, access to a 200+ faculty
                network, and robust curricula co-designed with business leaders,
                we are the leading tech-ed company for emerging economies.
              </p>
            </Animate.Fade>
          </div>

          <div className="hidden md:block">
            <Animate.Zoom>
              <img src={PeopleImg} width="90%" className="" alt="" />
            </Animate.Zoom>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyStorySection;
